import { HelpOutline } from '@mui/icons-material';
import { Button } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ModalController,
  ModalControllerProps,
} from '../../components/modal/modal-controller/ModalController';
import { Modal } from '../modal/base/Modal';

export interface HelpModalProps {
  linkText?: React.ReactNode;
  trigger?: ModalControllerProps['trigger'];
  children: React.ReactNode;
}

export const HelpModal = (props: HelpModalProps) => {
  const { children, linkText, trigger } = props;
  return (
    <ModalController
      trigger={(open) =>
        trigger ? (
          trigger(open)
        ) : (
          <Button
            size="small"
            variant="text"
            sx={{ fontSize: '0.75rem', textTransform: 'none', color: 'text.secondary' }}
            onClick={open}
          >
            <HelpOutline fontSize="small" sx={{ fontSize: '0.75rem', mr: 0.5 }} /> {linkText}
          </Button>
        )
      }
    >
      {({ show, onHide }) => (
        <Modal show={show} onHide={onHide} showCloseButton closeOnOutsideClick>
          <div style={{ lineHeight: '1.75rem' }}>{children}</div>
          <div className="mt-4 text-right">
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              onClick={onHide}
              sx={{ minWidth: '5rem' }}
            >
              <FormattedMessage id="common.actions.close" defaultMessage="Cerrar" />
            </Button>
          </div>
        </Modal>
      )}
    </ModalController>
  );
};
